export const environment = {
	production: false,
	iStoreUrl: "https://preorder.proquest.com/OA_HTML/pqdtibeCScpViewA.jsp?sitex=10020:22372:US&track=DxWeb",
	oneTrustKey: "15495670-c116-4ad3-bb4d-1625f90d192d",
	gtmKey: "GTM-K5FJZZ"
};
